<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="68"
      :height="24"
      viewBox="0 0 68 24"
  >
    <g data-name="그룹 8264" style="clip-path: url(#t3nm1j207a)">
      <path
          d="M21.355 1.276a9.222 9.222 0 0 0-5.12-1.1h-6.1C5.871.18 3.789 2.408 3.001 6.408 1.801 12.5.248 20.248.084 21.091c-.4 2.01.657 2.693 2.579 2.693h8.224c3.659 0 5.825-.557 7.462-1.574a7.792 7.792 0 0 0 3.552-5.027c.968-4.826-3.78-5.539-3.78-5.539a6.8 6.8 0 0 0 4.993-5.42s.735-3.406-1.763-4.947m-6.086 14.93c-.13.79-.746 1.8-2.84 1.8H7.722l.742-3.72h4.337c1.018 0 2.776.017 2.468 1.92m.8-8.756c-.185 1.334-1.172 1.73-3.319 1.73H9.466s.218-1.268.356-1.97a1.439 1.439 0 0 1 1.57-1.3h2.923c.275 0 1.986-.07 1.759 1.537m25.6 2.04h-3.447c-2.909 0-3.493 1.99-3.758 3.34-.1.521-.378 1.806-.378 1.806h4.4a4.065 4.065 0 0 1-4.2 3.555c-1.016 0-3.763.335-3.645-3.31.14-1.934.604-3.83 1.373-5.61 1.2-2.287 2.8-3.345 6.1-3.484a24.999 24.999 0 0 1 3.5.135 3.02 3.02 0 0 0 2.953-1.267 14.27 14.27 0 0 0 1.477-3.25c-.7-.314-1.421-.574-2.16-.778A22.48 22.48 0 0 0 38.801 0a14.817 14.817 0 0 0-10.085 3.364c-3.533 3.071-4.394 8.213-4.394 8.213-1.9 7.512 2 10.354 2 10.354 2.642 2.312 7.223 2.061 7.223 2.061a11.866 11.866 0 0 0 8.056-2.817 13.012 13.012 0 0 0 3.621-7.434c.459-2.567-.622-4.25-3.555-4.25M59.614.15c-6.241 0-10.135 2.373-11.526 9.335 0 0-2.371 11.917-2.383 12a2.113 2.113 0 0 0 .343 1.693c.046.053.096.101.149.146.45.327 1.002.484 1.557.443h4.339l1.618-7.8.059-.313h5.344c2.7 0 4.809-1.01 5.449-3.487.206-.786.34-1.59.4-2.4a41.913 41.913 0 0 0-6.871-.14c-1.632.164-2.768.488-3.469 1.611l.358-1.743c.652-2.814 2.638-3.613 4.777-3.613h3.575c2.144 0 3.495-.75 3.893-2.679.326-1.564.585-3.05.585-3.05L59.614.15z"
          fill="#3CB149"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 68,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
